module.exports = __webpack_public_path__ + "static/img/PayMe.0e108caf.webp";